export default "__VITE_ASSET___9TPWU_n__"